module.exports = __webpack_public_path__ + ".htaccess.bin";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/.htaccess
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/.htaccess
// module chunks = 12